import React from 'react';
import { Box } from '@mui/material';
import { CustomButton } from '../../../../../components/Button/Button';

const FormActions = ({ loading, isUpdateUser, onClose }) => {
  return (
    <Box sx={{ alignSelf: "end", display: "flex" }}>
      <CustomButton
        type="submit"
        variant="contained"
        className="add-user-submit-button"
        disabled={loading}>
        {isUpdateUser ? "Update" : "Add"}
      </CustomButton>
      <CustomButton
        variant="outlined"
        className="add-user-cancel-button"
        onClick={onClose}
        disabled={loading}>
        Cancel
      </CustomButton>
    </Box>
  );
};

export default FormActions; 